<!-- 聊天室 -->
<template>
    <div class="ky-chat-main">
        <div class="top-bar" v-if="chatListShow">
            <img v-if="!hideLogo" class="logo" src="../../assets/kayi-logo-white.png"/>
            <div class="img-text">
                <img class="my-avatar" :src="mySelfData.user && mySelfData.user.avatarImageUrl ? mySelfData.user.avatarImageUrl :require('../../../static/avatar.jpg')"/>
                <span>
                    <span>{{mySelfData.user && mySelfData.user.userName}}</span>
                    <i v-if="otherSys === 'ris'" class="el-icon-more" title="设置" @click="openSetting"></i>
                </span>
            </div>
        </div>
        <div class="chat-main" :style="!chatListShow ? 'height:100%':''">
            <chatList v-show="chatListShow" ref="chatList" :allUserGroups="allUserGroups" :otherSys="otherSys" :clickItem.sync="clickItem" :myUserId="myUserId" :pageType="pageType" @chatClick="chatClick" @changeGroupSetting="changeGroupSetting" @changeGroupDelete="changeGroupDelete" @addGroup="addVisible = true" @createGroup="createGroup('create')"></chatList>
            <div v-if="contentShow"  class="right-main flex">
                <div class="right-content">
                    <div v-if="otherSys !== 'applet'" id="back-to-list" class="el-icon-arrow-left more-icon-3 cursor hide" @click="backToList"></div>
                    <chatContent ref="chatContent" :closedChat.sync="closedChat" :patInfo="patInfo" :mySelfData="mySelfData" :userType="userType" :pageSize="pageSize" :clickItem.sync="clickItem" :otherSys="otherSys" :pageType="pageType" :myUserId="myUserId" @checkDataChange="checkDataChange" @settingClick="settingClick" @openMultiple="openMultiple" :API_ROOT="API_ROOT" :voiceTime="voiceTime" @goInVideo="goInVideo" @closeLoading="closeLoading"></chatContent>
                    <input-send ref="inputSend" :otherSys="otherSys" :askId="askId" :groupOutTime="groupOutTime" :allQuestNum="allQuestNum" :groupCreateTime="groupCreateTime" :closedChat.sync="closedChat" :patInfo="patInfo" :userType="userType" :myUserId="myUserId" :clickItem.sync="clickItem" :pageSize="pageSize" :multipleShow="multipleShow" @copyChat="copyChat" @sendMsgServer="sendMsgServer" @historyClick="historyClick" @goInVideo="goInVideo" @closeMultiple="closeMultiple" :API_ROOT="API_ROOT" :voiceTime="voiceTime" :VIDEO_URL="VIDEO_URL"></input-send>
                </div>
                <history ref="history" v-show="historyShow" :myUserId="myUserId" :clickItem="clickItem" :mySelfData="mySelfData" :historyShow.sync="historyShow" :API_ROOT="API_ROOT" :voiceTime="voiceTime"></history>
                <setting ref="setting" v-show="settingShow" :myUserId="myUserId" :clickItem="clickItem" :userType="userType" :otherSys="otherSys" :settingShow.sync="settingShow" @addPeopleGroup="addPeopleGroup"></setting>
            </div>
            <Welcome v-else class="welcome"></Welcome>
            <video-chat ref="videoChat" v-show="videoChatShow" :otherSys="otherSys" :peopleName="videoSendUserName" @goVideo="goVideo" @refuseVideo="refuseVideo" @copyAndGoVideo="copyAndGoVideo"></video-chat>
            <addGroup ref="addGroup" :addVisible.sync="addVisible" :myUserId="myUserId"></addGroup>
            <CreateGroup ref="createDialog" :createVisible.sync="createVisible" :myUserId="myUserId" :allUsers="allUserGroups.allUsers" :createParams="createParams" :clickItem="clickItem" :pageType="pageType" :peopleModalType="peopleModalType" :groupPeopleData="groupPeopleData"></CreateGroup>
        </div>
        <audio id="audio" src="./static/message/message-prompt.mp3"></audio>
        <loading v-if="loadingShow"></loading>
        <settingDialog :visible.sync="settingVisible" :userInfo.sync="mySelfData"></settingDialog>
    </div>
</template>

<script>
import chatList from './chat-list.vue'
import chatContent from './chat-content.vue'
import Welcome from './welcome.vue'
import InputSend from './input-send.vue'
import history from './history.vue'
import setting from './setting.vue'
import addGroup from './addGroup.vue'
import CreateGroup from './createGroup.vue'
import {batchUserData, getPatientConInfo, isExistGroup, joinGroup, getVideoToken, setReadMsg, clinicalInformation, getGroupDetailApi, sendMessageToGroup, lastUsersAndGroups, systemLogin, sysUserInfo} from '../../api/api.js'
import {getWeixinConfig, getVideoRoomId, getFormList4Chat} from '../../api/appletApi.js'
import loading from './loading.vue'
import VideoChat from './videoChat.vue'
// const Notify = require('notifyjs')// 不是我想要的那个notify,再看看吧
import Notify from '@wcjiang/notify'
import {getsignature} from '../../utils/sha1'
import {hex_md5} from '../../utils/md5.js'
import settingDialog from './settingDialog.vue'
const signalR = require('@aspnet/signalr')
/* const config = require('../../../static/config.js')
const API_ROOT = window.httpConfig.API_ROOT */

export default {
  name: 'kyChat',
  mixins: [],
  components: { chatList, chatContent, Welcome, InputSend, history, setting, addGroup, CreateGroup, loading, VideoChat, settingDialog },
  props: {
    loginParams: {
      Object,
      default: () => {}
    },
    createinfo: {
      Object,
      default: () => {}
    }
  },
  data () {
    return {
      allUserGroups: {},
      myUserId: '',
      connection: null,
      clickItem: {},
      pageType: '1',
      contentShow: false,
      chatListShow: window.httpConfig.otherSys !== 'applet',
      historyShow: false,
      settingShow: false,
      videoChatShow: false,
      addVisible: false,
      createVisible: false,
      multipleShow: false,
      createId: '', // 父页面传来的创建房间的id
      peopleModalType: '',
      groupPeopleData: [], // 当前组的成员数据
      createParams: {}, // 创建ris群组的参数
      pageSize: 'large', // 页面大小
      mySelfData: {},
      loadingShow: true,
      videoSendUserName: '', // 视频通话邀请方名称
      unVisibleMsg: 0,
      otherSys: window.httpConfig.otherSys, // 是否小程序、第三方系统
      /* API_ROOT: (window.top.window.g && window.top.window.g.CHAT_API_ROOT) ? window.top.window.g.CHAT_API_ROOT : window.httpConfig.API_ROOT,
      voiceTime: (window.top.window.g && window.top.window.g.voiceTime) ? window.top.window.g.voiceTime : window.httpConfig.voiceTime,
      VIDEO_URL: (window.top.window.g && window.top.window.g.VIDEO_URL) ? window.top.window.g.VIDEO_URL : window.httpConfig.VIDEO_URL */
      API_ROOT: window.httpConfig.API_ROOT,
      voiceTime: window.httpConfig.voiceTime,
      VIDEO_URL_PC: window.httpConfig.VIDEO_URL_PC,
      VIDEO_URL_PHONE: window.httpConfig.VIDEO_URL_PHONE,
      changeGroupFlag: true, // 是否可以改变群列表flag
      patInfo: {}, // 患者信息
      groupOutTime: null, // 附二医会话结束时长
      allQuestNum: null, // 附二医总的提问次数
      groupCreateTime: null, // 群聊创建时间
      closedChat: false, // 会话是否已结束
      askId: '',
      hideLogo: window.httpConfig.hideLogo,
      settingVisible: false,
      userType: 1
    }
  },
  watch: {
    loginParams: {
      async handler (val) {
        if (val.id && val.pageType) {
          this.myUserId = val.id
          this.pageType = val.pageType
          this.userType = val.userType // 用户类型 0:患者 1:医生 //黄志伟存的患者是2
          await this.loginToApi(this.myUserId)
          if (val.userName || val.dep) { // 带了名字或者部门就走用户同步接口后登录否则直接登录
            let params = {
              ...val
            }
            this.checkUserAndLogin(params)// 同步用户数据后登录
          } else {
            this.getMySelfData()
            this.login(this.myUserId).then(res => {
              this.chatListShow = false // 小程序进来就不让看人员列表了
              if (this.createinfo && this.createinfo.data) {
                /* if (this.pageSize === 'large') { // pc端需要列表走正常获取列表逻辑----加载会慢一点
                  this.createAutoMethod(this.createinfo)
                } else {
                  this.parentData = this.createinfo
                  getGroupDetailApi({id: this.createinfo.data.groupId}).then(data => { // 小程序不需要消息列表所以直接调用获取群组详情接口，进入群组
                    // this.loadingShow = false//跳转进去先不关闭loading等历史记录返回再关闭
                    this.isAutoPeople = true
                    this.joinRoom(data)// 进入聊天窗口
                  }).catch(() => { // 没有该群组会报错，先创建群组----走正常流程
                    this.isAutoPeople = true
                    this.judgeIsCreated(this.createinfo)
                  })
                } */
                this.createAutoMethod(this.createinfo)
                this.groupOutTime = this.createinfo.data.outTime // 附二医会话结束时间
                this.allQuestNum = this.createinfo.data.questNum // 附二医总的提问次数
                // this.videoRoomId = this.createinfo.data.videoRoomId
              }
            })
          }
        }
      },
      immediate: true
    }
  },
  computed: {},
  created () {
    // window.onresize = this.$chatUtils.debounce(this.windowResize, 50)
    this.windowResize()
    this.initNotify()
    this.getParentMessage()
    this.watchHiddenEvent()
    this.setWxFontSize()
  },
  mounted () {
    document.getElementsByTagName('body')[0].setAttribute('class', window.httpConfig.skin)
    /*  if (window.location.protocol.indexOf('https') > -1 || window.location.host.indexOf('localhost') > -1) {
      this.initMedia()
    } */

    /* let audioDom = document.getElementById('audio')
    // 触发交互
    audioDom.pause() */

    /*  var event = new Event('click')// 创建一个click事件
    document.addEventListener('click', function (e) {
      console.log('点击事件.............')
    }, false)
    document.dispatchEvent(event)// 派发事件

    document.getElementsByClassName('ky-chat-main')[0].click() */
    // if (this.isWeixin()) {
    //   this.initWx()
    // }
  },
  methods: {
    initMedia () { // 获取媒体权限
      try {
        if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
          navigator.mediaDevices.getUserMedia({ audio: true, video: false }).catch(error => {
            if (error.indexOf('navigator.getUserMedia is not a function') === -1) {
              this.$message.error(error)
            }
          })
        } else {
          navigator.getUserMedia({ audio: true, video: false }).catch(error => {
            if (error.indexOf('navigator.getUserMedia is not a function') === -1) {
              this.$message.error(error)
            }
          })
        }
      } catch (error) {
        if (error.indexOf('navigator.getUserMedia is not a function') === -1) {
          this.$message.error(error)
        }
      }
    },
    isWeixin () {
      return navigator.userAgent.toLowerCase().indexOf('micromessenger') !== -1
    },
    initWx () { // 设置微信对象
      getWeixinConfig({url: window.location.origin}).then(data => {
        // eslint-disable-next-line no-undef
        wx.config({
          debug: false,
          appId: data.appId,
          timestamp: data.timestamp,
          nonceStr: data.nonceStr,
          signature: data.signature,
          envVersion: data.envVersion,
          jsApiList: ['wx-open-launch-weapp', 'chooseImage', 'getLocalImgData'],
          openTagList: ['wx-open-launch-weapp']
        })
        // eslint-disable-next-line no-undef
        wx.ready(() => {
          console.log('配置完成')
        })
        // eslint-disable-next-line no-undef
        wx.error(function (res) {
          console.error('配置出错', res.errMsg)
        })
      })
    },
    loginToApi (uid) {
      return new Promise((resolve, reject) => {
        let key = hex_md5((uid + '@ky2024').toUpperCase()).toUpperCase()
        let params = {
          uid,
          key
        }
        systemLogin(params).then(data => {
          localStorage.setItem('token', data.accessToken)
          resolve()
        }).catch((err) => {
          reject(err)
        })
      })
    },
    setWxFontSize () { // 设置微信字体大小不受关怀模式影响--安卓
      if (typeof WeixinJSBridge === 'object' && typeof WeixinJSBridge.invoke === 'function') {
        handleFontSize()
      } else {
        if (document.addEventListener) {
          document.addEventListener('WeixinJSBridgeReady', handleFontSize, false)
        } else if (document.attachEvent) {
          document.attachEvent('WeixinJSBridgeReady', handleFontSize)
          document.attachEvent('onWeixinJSBridgeReady', handleFontSize)
        }
      }
      function handleFontSize () {
        // 设置网页字体为默认大小
        WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
        // 重写设置网页字体大小的事件
        WeixinJSBridge.on('menu:setfont', function () {
          WeixinJSBridge.invoke('setFontSizeCallback', { fontSize: 0 })
        })
      }
    },
    async login (userId) {
      return new Promise((resolve, reject) => {
        // eslint-disable-next-line no-undef
        let token = localStorage.getItem('token')
        this.connection = new signalR.HubConnectionBuilder().withUrl(this.API_ROOT + '/hubs/chathub', { accessTokenFactory: () => token, transport: signalR.HttpTransportType.WebSockets}).build()
        this.connection.serverTimeoutInMilliseconds = 40 * 1000
        this.connection.keepAliveIntervalInMilliseconds = 10 * 1000 * 2

        this.connection.start().then(async () => {
          return Promise.resolve()
        }).catch((err) => {
          return console.error(err.toString())
        })
        // 报错返回的消息
        this.connection.on('selfMsg', (message) => {
          // ws的报错信息会在这里显示
          this.$message.error(message)
          if (message === '您的账号在其他终端上登录') {
            this.isOtherLogin = true
            // eslint-disable-next-line no-undef
            this.$alert(`您的账号于${this.$dayjs().format('YYYY-MM-DD HH:mm')}在另一终端登录,已被迫下线`, '提示', {
              confirmButtonText: '重新登录',
              showClose: false,
              callback: action => {
                this.isOtherLogin = false
                this.login(userId)
              }
            })
          }
        })
        // 断连会走的方法
        this.connection.onclose(() => {
          if (!this.isOtherLogin) {
            setTimeout(() => {
              this.connection.start().then(() => {
                console.info('重连成功！')
              }).catch((err) => {
                this.$message.error('连接已断开，请重新进入')
                console.error(err.toString())
              })
            }, 5000)
          }
        })
        // 接收数据
        this.connection.on('receive', (message) => {
          console.log('message', message)
          let sortFlag = true
          if (message.chatType === 5 && message.content === '会话已结束' && this.userType === 0) { // 患者才关闭会话
            sortFlag = false
            this.closedChat = true
          } else if (message.chatType === 5 && message.content === '会话已重启') {
            this.closedChat = false
            this.clickItem.groupStatus = 1
            this.groupCreateTime = this.$dayjs().format('YYYY-MM-DD HH:mm:ss')
            this.$refs.inputSend.questNum += this.allQuestNum
            window.localStorage.setItem('clickItem', JSON.stringify(this.clickItem))
          }
          // 自己本人发送的消息并且是当前点击的人或组的id || 对方发送并且单聊消息是当前点击的对方发送的消息 || 对方发送并且群聊消息是当前点击的群组发送的消息
          if ((message.sendUser && message.sendUser.id === this.myUserId && message.groupId === this.clickItem.id) || (message.sendUser && message.chatReceiveType === 0 && message.sendUser.id === this.clickItem.id) || (message.chatReceiveType === 1 && message.groupId === this.clickItem.id)) {
            this.$refs.chatContent && this.$refs.chatContent.setChatListFunc(message, true)
            if (message.sendUser && ((message.sendUser.id === this.myUserId && this.userType === 0) || (message.sendUser.id !== this.myUserId && this.userType !== 0)) && (message.chatType === 0 || message.chatType === 4 || message.chatType === 6)) { // 判断是患者发送的文字、语音、通话消息才需要减去提问次数
              this.$refs.inputSend.questNumFunc()
            }
            if (message.chatReceiveType === 0) { // 单聊
              let id = message.groupId// 接收方id
              if (id === this.myUserId) { // 如果接收方是自己，就拿发送方的id
                id = message.sendUser.id
              }
              this.$refs.chatList.updateLastMsg('user', id, message)// 更新左侧列表显示的最新消息
              if (sortFlag) {
                this.$refs.chatList.sortList('user', id)
              }
            } else { // 群聊
              this.$refs.chatList.updateLastMsg('group', message.groupId, message)// 更新左侧列表显示的最新消息
              if (sortFlag) {
                this.$refs.chatList.sortList('group', message.groupId)
              }
            }
            if (message.chatType !== 5) {
              this.setReadMsgToAPI()
            }
          } else { // 其他人或组的消息--添加小红点
            if (message.chatReceiveType === 0) { // 个人未读
              let id = message.groupId// 接收方id
              if (id === this.myUserId) { // 如果接收方是自己，就拿发送方的id
                id = message.sendUser.id
              }
              this.$refs.chatList.appendCircle('user', id)// 设置未读标志
              this.$refs.chatList.updateLastMsg('user', id, message)// 更新左侧列表显示的最新消息
              if (sortFlag) {
                this.$refs.chatList.sortList('user', id)
              }
            } else { // 群组未读
              this.$refs.chatList.appendCircle('group', message.groupId)// 设置未读标志
              this.$refs.chatList.updateLastMsg('group', message.groupId, message)// 更新左侧列表显示的最新消息
              if (sortFlag) {
                this.$refs.chatList.sortList('group', message.groupId)
              }
            }

            this.sendToParentMsg()// 提示父页面iframe收到消息了
          }

          /* 视频通话加的判断 */

          if (message.chatType === 6 && message.sendUser.id !== this.myUserId) { // 如果接收方是自己，并且是视频通话消息，打开右侧视频判断页面
            this.videoChatMsg = message
            this.videoSendUserName = message.sendUser.userName
            this.videoChatShow = true
          }

          this.setNotifyData(message)// 设置通知提示消息
        })
        // 获取左侧列表
        /* this.connection.on('allUsers', (data) => {
              this.loadingShow = false
              console.log('allUsers', data)
              if (data) {
                this.allUserGroups = data
                this.initClick()
                this.dealAllUserForList()
                this.hasUserGroupsData = true // 是否已拿到数据
                if (this.isOpenCreate) {
                  this.openCreateGroup()
                  this.isOpenCreate = false
                }
              } else {
                console.error('error,please restart ChatHub')
              }
            }) */

        this.connection.on('onlineUserChange', (data) => {
          console.log('在线人数', data)
          if (data) {
            setTimeout(() => {
              this.$refs.chatList.onlineUserChange(data)
            }, 3000)
          } else {
            console.error('error,please restart ChatHub')
          }
        })
        this.connection.on('MyGroups', (data) => { // 群组改变触发事件
          console.log('我的群组', data)
          //   this.newGroupData = data // 改变的群组的返回数据
          // this.groupCreateTime = data.changeGroup.createdTime
          //   if (this.changeGroupFlag) { // 附二的自动创建群聊后不立马进入群聊，推送一条病历后再调用进入群聊
          console.log('我的群组（群组改变）里进入群组')
          this.$refs.chatList.changeGroups(data)
          //   }
          if (this.otherSys === 'applet') {
            this.setAppletTitle()
          }
        })
        this.getAllUserGroups().then(() => {
          resolve()
        })// 走api获取用户列表
      })
    },
    async getAllUserGroups () {
      return new Promise((resolve, reject) => {
        let params = {
          userid: this.myUserId,
          ignoreusers: window.httpConfig.otherSys === 'applet'// 是否不查询所有用户
        }
        lastUsersAndGroups(params).then(data => {
          this.loadingShow = false
          if (data) {
            this.allUserGroups = data
            this.dealAllUserForList()
            /* this.hasUserGroupsData = true // 是否已拿到数据
                if (this.isOpenCreate) {
                  this.openCreateGroup()
                  this.isOpenCreate = false
                } */

            this.$nextTick(() => {
              if (this.openChatFlag) { // 父页面发来打开对话框，未获取用户列表的话就再次打开下 有指定的就先打开指定的否则默认上次的
                this.setClick(this.chatName)
              } else {
                // this.initClick()//不默认打开上次的会话
              }
              if (this.openTeamFlag) {
                this.changeTeam(this.team)
              }
            })
          }
          resolve()
        })
      })
    },
    setNotifyData (message) {
      if (!this.isVisibility() || (this.isVisibility() && this.parentHidden)) { // 不为当前页面有提醒功能-----以后做到@功能上
        this.unVisibleMsg++
        this.iN.setFavicon(this.unVisibleMsg)
        this.iN.setTitle(true)
        let notifymsg = ''
        if (message.chatType === 0) { // 文字消息
          notifymsg = `${message.sendUser.userName}:${message.content}`
        } else if (message.chatType === 1) {
          notifymsg = `${message.sendUser.userName}:发来一张图片`
        } else if (message.chatType === 2) {
          notifymsg = `${message.sendUser.userName}:发来一份文件`
        } else if (message.chatType === 4) {
          notifymsg = `${message.sendUser.userName}:发来一条语音`
        } else if (message.chatType === 6) {
          notifymsg = `${message.sendUser.userName}:邀请您视频通话`
        } else if (message.chatType === 7) {
          notifymsg = `${message.sendUser.userName}:发来一份病历`
        } else if (message.chatType === 8) {
          notifymsg = `${message.sendUser.userName}:发来一份应用消息`
        } else if (message.chatType === 9) {
          notifymsg = `${message.sendUser.userName}:发来一份信息`
        }
        // let newId = `user-${message.sendUser.id}`
        this.iN.notify({
          title: '即时通讯新通知',
          body: notifymsg,
          icon: './static/message/message.png',
          audio: {
            file: './static/message/message-prompt.mp3'// 可以使用数组传多种格式的声音文件
          },
          onclick: () => {
            window.focus()
            // $('#'+newId).click()
            this.iN.setTitle()
            this.iN.faviconClear()
            this.unVisibleMsg = 0
          }
        })
        console.log('发通知.......', this.iN)
        this.iN.player() // 必须点击过一次页面以后才会有声音，与浏览器策略有关系，解决不了
        /*  setTimeout(() => {
          this.iN.stopPlay()
        }, 10) */

        /* var audio = document.createElement('audio')
        audio.src = './static/message/message-prompt.mp3'
        audio.setAttribute('autoplay', 'autoplay') */

        // document.getElementById('audio').play()

        // showNotice(`${notifymsg}`,message.userId)//出通知
        // notice = sendNotificationFn('有新的通知', 500);//改标题
      }
    },
    // 页面是否隐藏
    isVisibility () {
      let hiddenProperty = 'hidden' in document ? 'hidden'
        : 'webkitHidden' in document ? 'webkitHidden'
          : 'mozHidden' in document ? 'mozHidden'
            : null
      return !document[hiddenProperty]
    },
    watchHiddenEvent () {
      // 监听页面是否激活
      let hiddenProperty = 'hidden' in document ? 'hidden'
        : 'webkitHidden' in document ? 'webkitHidden'
          : 'mozHidden' in document ? 'mozHidden'
            : null
      let visibilityChangeEvent = hiddenProperty.replace(/hidden/i, 'visibilitychange')
      let that = this
      let onVisibilityChange = () => {
        if (!document[hiddenProperty]) {
          // 页面激活
          // if(notice){
          //     clearInterval(notice);
          // }
          that.iN.setTitle()
          that.iN.faviconClear()
          that.unVisibleMsg = 0
          if (this.otherSys === 'applet') { // 重新设置页面title
            this.setAppletTitle()
          }
        //   console.log('页面激活')
        } else {
        //   console.log('页面非激活')
        }
      }
      document.addEventListener(visibilityChangeEvent, onVisibilityChange)
    },
    async setReadMsgToAPI () { // 设置已读
      let params = {
        userId: this.myUserId,
        otherId: this.clickItem.id,
        type: this.clickItem.type,
        // eslint-disable-next-line no-undef
        startTime: this.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
        pageSize: 0
      }
      await setReadMsg(params)
    },
    sendToParentMsg () {
      // 告诉嵌套的父页面接收到消息了，标记提示小红点
      let data = {
        type: 'chatGetMsg'
      }
      this.$chatUtils.postToParent(data)
    },
    getParentMessage () { // iframe接收父页面发来的消息--一般汪小梅那边用
      this.$chatUtils.getMessageFromParent(async (event) => {
        let msg = event.data
        console.log('父页面消息。。。。', msg)
        if (msg.type === 'create') { // 创建群---手动选人
          this.isAutoPeople = false
          this.parentData = msg
          //   if (this.hasUserGroupsData) {
          // this.openCreateGroup()
          this.judgeIsCreated(this.parentData)
        //   } else {
        //     this.isOpenCreate = true
        //   }
        }
        if (msg.type === 'createAuto') { // 创建群---自动添加成员
          this.createAutoMethod(msg)
        }
        if (msg.type === 'comment') { // 评论
          this.$refs.inputSend.sendMsg('comment', msg.data)
        }
        if (msg.type === 'login') { // 登录
          let params = {
            id: msg.data.id,
            userName: msg.data.userName,
            dep: msg.data.dep
          }
          this.myUserId = msg.data.id
          this.pageType = msg.data.pageType
          await this.loginToApi(this.myUserId)
          this.checkUserAndLogin(params)
        }
        if (msg.type === 'parentHidden') { // 父页面通知界面是否被隐藏
          this.parentHidden = msg.data
        }
        if (msg.type === 'openChat') { // 父界面通知打开指定聊天用户的窗口
          this.chatName = msg.data.name
          this.openChatFlag = true
          this.setClick(this.chatName)
        }
        if (msg.type === 'openTeam') { // 打开指定组别
          this.team = msg.data.team
          this.openTeamFlag = true // 等拿到数据切换组
          this.changeTeam(this.team)
        }
        if (msg.type === 'pasteImg') { // 粘贴粘贴板东西到输入框
          let img = msg.data
          this.$refs.inputSend.screenShootCallBack(img)
        }
      })
    },
    createAutoMethod (msg) { // 自动创建群组的方法
      this.isAutoPeople = true // 自动添加群成员
      this.parentData = msg
      /*  if (this.hasUserGroupsData) { // 异步已返回列表数据
        this.openCreateGroup()
      } else {
        this.isOpenCreate = true
      } */
      this.judgeIsCreated(this.parentData)
    },
    sendMsg (type, data) { // 发送消息，暴露给外部调用
      this.$refs.inputSend.sendMsg(type, data)
    },
    openCreateGroup () { // 判断是否有父页面传来打开弹窗或者打开聊天页的消息 单独的群data
      if (this.allUserGroups.allGroups) {
        let groups = this.allUserGroups.allGroups.find(res => {
          if (this.loginParams.pageType === '1') {
            return res.groupType === 'Simple'
          } else {
            return res.groupType === 'RIS'
          }
        })
        if (groups) {
          let item = groups.groups.find(v => {
            return v.groupId === this.parentData.data.groupId
          })
          this.joinRoom(item)// 进入聊天窗口
        } else {
          // 打开创建群弹窗还是加入群组
          this.judgeIsCreated(this.parentData)
        }
      } else {
        // 打开创建群弹窗还是加入群组
        this.judgeIsCreated(this.parentData)
      }
    },
    joinRoom (item) { // 进入聊天室
      if (item) {
        // this.getMySelfData(item)
        // this.setGroupToList(item)
        // this.groupCreateTime = item.updateTime // 获取群组创建时间 -- 附二小程序需求
        // this.getSessionTime(item)
        // 该群存在则打开聊天窗口
        this.$nextTick(() => {
          console.log('群组获取的item', item)
          this.$refs.chatList.sortList('group', item.groupId)
          this.$refs.chatList.getChart(1, item)
          this.askId = this.parentData.data.askId
          if (this.askId) {
            getPatientConInfo({id: this.askId}).then(data => { // 获取患者病历数据
              data = JSON.parse(data)
              if (data.code === 200) {
                if (data.data) {
                  this.patInfo = data.data
                }
              }
            })
          }
          if (this.otherSys === 'applet') {
            this.setAppletTitle()
          }
        })
      }
    //   else {
    //     // 该群不存在--打开创建群弹窗还是加入群组
    //     this.judgeIsCreated(this.parentData)
    //   }
    },
    setAppletTitle () { // 设置小程序的头部显示
      if (this.createinfo.data) {
        let userArr = this.createinfo.data.userIds
        if (userArr.length > 2 || userArr.length === 1) { // 群人数大于两人或者只有一个人就显示房间名称
          document.title = this.createinfo.data.roomName
        } else { // 俩人就显示对方的名称
          let obj = userArr.find(v => {
            return v.id !== this.myUserId
          })
          document.title = obj.userName + '-' + obj.dep
        }
      }
    },
    judgeIsCreated (msg) { // 打开创建群弹窗还是加入群组
      let params = {
        id: msg.data.groupId,
        type: Number(this.pageType),
        userid: this.myUserId
      }
      isExistGroup(params).then(data => {
        if (data === 0) { // 已加入
          getGroupDetailApi({id: msg.data.groupId}).then(data => { // 小程序不需要消息列表所以直接调用获取群组详情接口，进入群组
            this.loadingShow = false
            this.joinRoom(data)// 进入聊天窗口
          })
        } else if (data === 1) { // 不存在
          this.loadingShow = false
          this.createdGroup(msg)
        } else if (data === 2) { // 未加入
          this.loadingShow = false
          this.$confirm('该群组已存在，是否加入群组？')
            .then(_ => {
              let params = {
                userId: this.myUserId,
                groupId: msg.data.groupId
              }
              joinGroup(params).then(data => {
                this.$message.success('加入群成功')
                getGroupDetailApi({id: msg.data.groupId}).then(data => { // 小程序不需要消息列表所以直接调用获取群组详情接口，进入群组
                  this.$refs.chatList.changeGroups({type: 0, changeGroup: data}, true)// 左侧列表添加该群并不跳转进群聊里
                  this.joinRoom(data)// 进入聊天窗口
                })
              })
            })
        }
      })
    },
    createdGroup (msg) { // 创建房间
      if (this.isAutoPeople) { // 自动添加群成员创建群
        if (this.createinfo && this.createinfo.data) { // 附二医那边需把群成员都同步以后再创建群聊
          let groupUsers = this.createinfo.data.userIds
          groupUsers.forEach(v => {
            v.avatarImageUrl = v.img
          })
          batchUserData(groupUsers).then(res => {
            let userIds = []
            msg.data.userIds.forEach(v => {
              userIds.push(v.id)
            })
            let params = {
              ...msg.data,
              groupName: msg.data.roomName,
              createdUserId: this.myUserId,
              groupType: Number(this.pageType),
              groupStatus: 1,
              updateTime: this.$dayjs().format('YYYY-MM-DD HH:mm:ss'),
              users: msg.data.userIds,
              userIds
            }
            this.askId = params.askId
            // if (params.askId) {
            //   this.changeGroupFlag = false// 创建完房间以后不要立马进入房间
            // }
            this.createGroupAuto(params).then(res => { // 自动创建房间成功
              // 通过病人id获取病历数据
              // 发送病人数据
              // 调用this.$refs.chatList.changeGroups(data)
            //   this.groupCreateTime = this.$dayjs().format('YYYY-MM-DD HH:mm:ss') // 获取群组创建时间 -- 附二小程序需求
              if (params.askId) {
                getPatientConInfo({id: params.askId}).then(data => {
                  data = JSON.parse(data)
                  if (data.code === 200) {
                    data = data.data
                    if (data) { // 有病历数据就推送一条消息后再进入群聊
                      console.log('获取到数据并推送消息')
                      this.patInfo = data
                      //   this.newGroupData = {type: 0, changeGroup: params}
                      this.sendMsgApi(params.groupId, data, true)
                      setTimeout(() => {
                        // this.sendQuestMsg(params.groupId)
                      }, 1000)
                    } else { // 没有病历数据就直接进入群聊
                      console.log('没有病历直接跳转到群组')
                      //   this.changeGroupFlag = true
                      //   this.$refs.chatList.changeGroups(this.newGroupData)// 跳转进群聊里
                      setTimeout(() => {
                        // this.sendQuestMsg(params.groupId)
                      }, 1000)
                    }
                  }
                })
              }
              if (this.otherSys === 'applet') {
                this.setAppletTitle()
              }
            })
          })
        } else {
          this.createGroupAuto(msg.data)
        }
      } else { // 仅打开创建页面
        this.createParams = msg.data
        this.createVisible = true
        this.peopleModalType = 'create'
      }
    },
    sendQuestMsg (groupId) {
      // 获取问卷----发送可以首次发送的问卷 //TODO:这个id是要医生的id myUserId不一定就是医生的id
      getFormList4Chat({userId: this.myUserId}).then(data => {
        if (data) {
          data.forEach(v => {
            if (v.beingUsed === 1) {
              v.msgType = 4
              /* let params = {
                groupId: groupId,
                sendUserId: this.myUserId,
                chatType: 8,
                content: JSON.stringify(v)
              }
              sendMessageToGroup(params) */

              let inputData = {
                receiveUserId: groupId,
                chatReceiveType: this.clickItem.type,
                atUserIds: '',
                chatType: 8,
                content: JSON.stringify(v)
              }
              this.sendMsgServer(inputData)
            }
          })
        }
      })
    },
    sendMsgApi (groupId, data) {
      /* return new Promise((resolve, reject) => {
        let params = {
          userId: this.myUserId,
          groupId,
          content: JSON.stringify(data)
        }
        clinicalInformation(params).then(res => { // 该接口只推送病历消息
          console.log('推送病历成功消息并进入群组')
          //   this.changeGroupFlag = true
          //   this.$refs.chatList.changeGroups(this.newGroupData)// 左侧列表添加该群并跳转进群聊里
          resolve()
        })
      }) */
      let inputData = {
        receiveUserId: groupId,
        chatReceiveType: this.clickItem.type,
        atUserIds: '',
        chatType: 7,
        content: JSON.stringify(data)
      }
      this.sendMsgServer(inputData)
    },
    createGroupAuto (data) { // 自动创建群聊
      return new Promise((resolve, reject) => {
        let params = {
          groupId: data.groupId,
          groupName: data.roomName,
          createdUserId: this.myUserId,
          groupType: Number(this.pageType),
          groupStatus: 1,
          userIds: data.userIds,
          roomType: data.roomType, // 房间类型--附二
          isPay: data.isPay, // 是否收费--附二
          outTime: data.outTime, // 群聊有效时间--附二
          questNum: data.questNum >= 0 ? data.questNum : null // -1代表的是无限次数，给后端需要处理成null
        }
        this.$refs.createDialog.saveCreateApi(params, false).then(() => {
          resolve()
        })
      })
    },
    checkUserAndLogin (params) { // 同步用户数据后登录
      /* let params = {
        id: msg.data.id,
        userName: msg.data.userName,
        dep: msg.data.dep
      } */
      batchUserData([params]).then(data => {
        this.getMySelfData().then(res => {
          if (this.otherSys === 'ris' && !this.mySelfData.user.team) { // ris系统有team字段
            this.settingVisible = true
          }
        })
        this.login(this.myUserId).then(res => {
          if (this.createinfo && this.createinfo.data) { // 有群组的数据，需创建群组或者加入群组
            /* if (this.pageSize === 'large') { // pc端需要列表走正常获取列表逻辑----加载会慢一点
              this.createAutoMethod(this.createinfo)
            } else { // 小程序为了快点进入页面就先获取群组详情，如果没有群组再走创建群组方法
              this.parentData = this.createinfo
              getGroupDetailApi({id: this.createinfo.data.groupId}).then(data => { // 小程序不需要消息列表所以直接调用获取群组详情接口，进入群组
                // this.loadingShow = false//跳转进去先不关闭loading等历史记录返回再关闭
                this.isAutoPeople = true
                this.joinRoom(data)// 进入聊天窗口
              }).catch(() => { // 没有该群组会报错，先创建群组----走正常流程

              })
            } */
            this.createAutoMethod(this.createinfo)
            this.groupOutTime = this.createinfo.data.outTime // 附二医会话结束时间
            this.allQuestNum = this.createinfo.data.questNum // 附二医总的提问次数
            // this.videoRoomId = this.createinfo.data.videoRoomId
          }
        })
      })
    },
    initNotify () {
      // 生成消息提示实例
      // eslint-disable-next-line no-undef
      this.iN = new Notify({
        effect: 'flash',
        interval: 500,
        message: '有消息拉！',
        audio: {
          file: './static/message/message-prompt.mp3'// 可以使用数组传多种格式的声音文件
        },
        notification: {
          title: '通知！',
          icon: './static/message/message.png',
          body: '您来了一条新消息'
        }
      })
    },
    dealAllUserForList () { // 筛选出自己的数据----有用户列表
      if (this.allUserGroups.allUsers && this.allUserGroups.allUsers.length > 0) {
        this.allUserGroups.allUsers.forEach((el, i) => {
          if (el.user.id === this.myUserId) {
            this.mySelfData = el
          }
        })
      }
    },
    getMySelfData (group) { // 筛选出自己的数据----无用户列表，有group
    //   if (!this.mySelfData.user) {
    //     let obj = group.users.find((v) => {
    //       return v.id === this.myUserId
    //     })
    //     this.mySelfData = {user: obj}
    //   }
      return new Promise((resolve, reject) => {
        sysUserInfo().then(data => {
          this.mySelfData = {user: data}
          resolve()
        }).catch(() => {
          // eslint-disable-next-line prefer-promise-reject-errors
          reject()
        })
      })
    },
    setGroupToList (group) { // 如果这条数据不存在群组列表里，就把这条数据插入进去
      let groups = this.allUserGroups.allGroups[0].groups
      let index = groups.findIndex((v) => {
        return v.groupId === group.groupId
      })
      if (index < 0) {
        groups.unshift(group)
      }
    },
    settingClick () {
      this.settingShow = !this.settingShow
      this.historyShow = false
    },
    historyClick () {
      this.historyShow = !this.historyShow
      this.settingShow = false
    },
    copyAndGoVideo () { // 接收视频并复制链接----给pc端的视频地址
      this.videoChatShow = false
      let chatRoomId = this.videoChatMsg.content
      if (this.VIDEO_URL.indexOf('mbmeeting') > -1) { // 移动端地址
        getVideoRoomId({applyId: chatRoomId}).then((val) => {
          let newId = val
          getVideoToken().then(res => {
            if (res) {
              let token = res
              let roomId = newId
              let userId = this.myUserId
              let userName = this.mySelfData.user.userName
              let url = `${this.VIDEO_URL_PC}/#/chatJoin?token=${token}&room_id=${roomId}&user_id=${userId}&user_name=${userName}&sysType=kyChat`
              this.copyText(url)// 复制到粘贴板
            }
          })
        })
      } else {
        getVideoToken().then(res => {
          if (res) {
            let token = res
            let roomId = chatRoomId
            let userId = this.myUserId
            let userName = this.mySelfData.user.userName
            let url = `${this.VIDEO_URL_PC}/#/chatJoin?token=${token}&room_id=${roomId}&user_id=${userId}&user_name=${userName}&sysType=kyChat`
            this.copyText(url)// 复制到粘贴板
          }
        })
      }
    },
    copyText (str) { // 复制到粘贴板
      const input = document.createElement('input')
      input.setAttribute('readonly', 'readonly')
      input.setAttribute('value', str)
      document.body.appendChild(input)
      input.setSelectionRange(0, 9999)
      input.select()
      document.execCommand('copy')
      document.body.removeChild(input)
      this.$message.success('复制链接地址成功')
    },
    goVideo () { // 接收视频
      this.videoChatShow = false
      this.goInVideo(this.videoChatMsg.content)
    },
    refuseVideo () { // 拒绝视频
      this.videoChatShow = false
    },
    goInVideo (chatRoomId) {
      // 先调起api获取token
      if (this.VIDEO_URL.indexOf('mbmeeting') > -1) { // 移动端地址
        /* let videoRoomId = this.videoRoomId
        if (videoRoomId) {
          videoRoomId = videoRoomId.substring(0, 32)// 截取32位
        } */
        // 移动端新视频地址需要新的roomid传参
        let applyId = chatRoomId || (this.createinfo && this.createinfo.data.videoId) || this.clickItem.id // 接听id 小程序videoId 房间id
        getVideoRoomId({applyId}).then((val) => {
          let newId = val
          let params = {
            //   roomid: chatRoomId || videoRoomId || this.clickItem.id, // 接听的id 小程序传来的特殊id 群组id
            roomid: newId, // 接听的id 小程序传来的特殊id 群组id 移动端视频换了所以传参也换了用这种
            username: this.mySelfData.user.userName,
            hospitalcode: '47000593033030211A1001',
            timestamp: new Date().getTime(),
            signature: ''
          }
          params.signature = getsignature(params.roomid, params.username, params.timestamp)
          // let url = `${this.VIDEO_URL}?roomid=${params.roomid}&username=${params.username}&hospitalcode=${params.hospitalcode}&timestamp=${params.timestamp}&signature=${params.signature}`
          let url = `${this.VIDEO_URL}?roomid=${params.roomid}&username=${params.username}&userid=${this.myUserId}`
          // window.open(url, '', 'width=700,height=500,titlebar=no,location=no,top=200,left=500,toolbar=no') //ios不支持改为window.loaction
          window.location.href = url
          //   videoWindow.focus()
          if (!chatRoomId) { // 主动发起的视频则发送一条数据给对方
            let params = {
              receiveUserId: this.clickItem.id,
              chatReceiveType: this.clickItem.type,
              atUserIds: '',
              chatType: 6,
              content: this.clickItem.id// 群组id
            }
            this.sendMsgServer(params)
          }
        })
      } else { // pc端地址
        getVideoToken().then(res => {
          if (res) {
            let token = res
            let roomId = chatRoomId || this.clickItem.id // this.$chatUtils.getUid()
            let userId = this.myUserId
            let userName = this.mySelfData.user.userName
            let url = `${this.VIDEO_URL}/#/chatJoin?token=${token}&room_id=${roomId}&user_id=${userId}&user_name=${userName}&sysType=kyChat`
            window.open(url, '', 'width=700,height=500,titlebar=no,location=no,top=200,left=500,toolbar=no')
            //   videoWindow.focus()
            if (!chatRoomId) { // 主动发起的视频则发送一条数据给对方
              let params = {
                receiveUserId: this.clickItem.id,
                chatReceiveType: this.clickItem.type,
                atUserIds: '',
                chatType: 6,
                content: roomId
              }
              this.sendMsgServer(params)
            }
          }
        })
      }
    },
    changeGroupSetting () {
      // 判断是否开着群组页面，是否要刷新群组详情
      if (this.settingShow) {
        this.$refs.setting.getGroupDetail()
      }
    },
    changeGroupDelete () {
      this.contentShow = false
      if (this.pageSize === 'small') {
        this.chatListShow = true
      }
    },
    backToList () {
      this.changeGroupDelete()
      if (this.pageSize === 'small') {
        this.clickItem = {}
        this.$refs.chatList.setActive(this.clickItem)
      }
    },
    chatClick (params) { // 左侧列表选中一条数据
      this.contentShow = true
      // 调整屏幕大小
      if (this.pageSize === 'small') {
        this.chatListShow = false
      } else {
        this.$nextTick(() => { // 光标自动到输入框中
          this.$refs.inputSend.$refs.pcInput.moveTo()
        })
      }

      this.groupCreateTime = params.updateTime

      this.settingShow = false
      this.historyShow = false

      // 在切换content以前，通知关闭一下ris的检查数据
      let data = {
        type: 'closeRis'
      }
      this.$chatUtils.postToParent(data)
    },
    sendMsgServer (param) {
      this.connection.invoke('SendNew', param)
        .then(function () {

        })
        .catch(function (err) {
          return console.error(err.toString())
        })
    },
    createGroup (val) {
      this.createVisible = true
      this.peopleModalType = val
    },
    addPeopleGroup (val) {
      this.groupPeopleData = val
      this.createGroup('add')
    },
    windowResize () { // 判断页面大小
      let width = window.innerWidth
      if (width <= 663) {
        this.pageSize = 'small'
        if (this.createinfo.type === 'createAuto') {
          this.chatListShow = false// 小程序先默认不展示list
        } else {
          this.chatListShow = true
        }
        this.contentShow = false
      } else {
        this.pageSize = 'large'
        this.chatListShow = true
      }
      if (width <= 663) { // 真正的手机端大小视频用兰天求移动端的大小
        this.VIDEO_URL = this.VIDEO_URL_PHONE
      } else { // 手机大小以上的视频用严秀伟的视频
        this.VIDEO_URL = this.VIDEO_URL_PC
      }
    },
    initClick () {
      if (this.pageSize === 'large') {
        // 初始点击
        let clickItem = JSON.parse(window.localStorage.getItem('clickItem'))
        if (clickItem && clickItem.id !== this.myUserId) {
          this.$nextTick(() => {
            let obj = null
            if (clickItem.type === 0) { // 单聊
              obj = this.allUserGroups.allUsers.find(v => {
                return v.user.id === clickItem.id
              })
            } else { // 群聊
              if (this.pageType === '1') { // 普通群聊
                let item = this.allUserGroups.allGroups.find(res => {
                  return res.groupType === 'Simple'
                })
                if (item) {
                  obj = item.groups.find(v => {
                    return v.groupId === clickItem.id
                  })
                }
              } else { // RIS群聊
                if (this.pageType === '2') { // RIS群聊
                  let item = this.allUserGroups.allGroups.find(res => {
                    return res.groupType === 'RIS'
                  })
                  if (item) {
                    obj = item.groups.find(v => {
                      return v.groupId === clickItem.id
                    })
                  }
                }
              }
            }
            if (obj) {
              obj.isClick = true
              this.$refs.chatList.getChart(clickItem.type, obj)
            }
          })
        }
      }
    },
    setClick (name) { // 指定显示单聊对话框
      if (this.allUserGroups.allUsers) {
        this.openChatFlag = false
        let obj = this.allUserGroups.allUsers.find(v => {
          return v.user.userName === name
        })

        if (obj) {
          this.$refs.chatList.team = obj.user.team
          this.$refs.chatList.filterUserChange()
          obj.isClick = true
          this.$refs.chatList.getChart(0, obj)
        }
      }
    },
    changeTeam (team) { // 切换组
      if (this.allUserGroups.allUsers) {
        this.openTeamFlag = false
        this.$refs.chatList.team = team
        this.$refs.chatList.filterUserChange()
      }
    },
    openSetting () {
      this.settingVisible = true
    },
    openMultiple () {
      // 打开多选的工具条
    //   this.$refs.inputSend.multipleShow = true
      this.multipleShow = true
    },
    closeMultiple () {
      this.multipleShow = false
      this.$refs.chatContent.closeMultiple()
    },
    checkDataChange (val) {
      this.$refs.inputSend.checkNum = val
    },
    copyChat () {
      this.$refs.chatContent.copyChat()
    },
    closeLoading () {
      this.loadingShow = false
    }
  },
  beforeDestroy () {
    this.connection.stop()
  },
  destroyed () {}
}
</script>
<style scoped lang="scss">
.ky-chat-main{
    // width:calc(100% - 2px);
    width:100%;
    height: 100%;
    min-width: 320px;//最小限制320px
    font-size: 15px;
    // border-left: 1px solid #ccc;
    // border-right: 1px solid #ccc;
    .top-bar{
        width:100%;
        height:55px;
        // background: #0FC6C2;
        .logo{
            height: 36px;
            margin-left: 10px;
            margin-top: 10px;
        }
        .my-avatar{
            width:44px;
            height:44px;
        }
        .img-text{
            float: right;
            margin-top: 6px;
            margin-right: 22px;
            img{
                border-radius: 5px;
            }
            >span{
                float: right;
                margin-top: 12px;
                color: #fff;
                margin-left: 10px;
            }
            i{
                margin-left:5px;
                cursor:pointer
            }
        }
    }
}
#back-to-list{
    display: none;
}
.chat-main{
    width:100%;
    height: calc(100% - 56px);
    display:flex;
    .right-main{
        flex:1;
        height:100%;
        background: #f1f1f1;
        position: relative;
        .right-content{
            height: 100%;
            flex:1;
            position: relative;
            display: flex;
            flex-direction: column;
        }
    }
    .more-icon-3{
        position: absolute;
        top: 20px;
        left: 15px;
    }
}
</style>
<style lang='scss'>
@media screen and (max-width: 1240px) and (min-width:664px){/* 平板 */

    .history,.setting{
        position: absolute!important;
        right: 0px;
        height: 100%!important;
        width: 100%!important;
    }
    #back-to-main{
        display: block!important;
    }
    .left-user{
        width: 230px!important;
        height: 100%!important;
        background: #fff;
        display: flex;
        flex-direction: column;
    }
}
@media screen and (max-width:663px){/* 手机 */
    .history,.setting,.videoView{
        position: absolute!important;
        right: 0px;
        height: 100%!important;
        width: 100%!important;
    }
    #back-to-main{
        display: block!important;
    }
    #back-to-list{
        display: block!important;
        font-size: 18px;
        top: 16px!important;
    }
    .left-user{
        width: 100% !important;;
        height: 100% !important;
        background: #fff;
        display: flex;
        flex-direction: column;
    }
    .logo-div{
        display: none;
    }
    .welcome{
        display: none!important;
    }
}
</style>
<style lang="scss">
/* 滚动条样式 */
.ky-chat-main {
    /* 设置滚动条的样式 */
    ::-webkit-scrollbar {
        width:8px;
        height: 8px;
    }
    /* 滚动槽 */
    ::-webkit-scrollbar-track {
        -webkit-box-shadow:inset006pxrgba(0,0,0,0.3);
        border-radius:10px;
    }
    /* 滚动条滑块 */
    ::-webkit-scrollbar-thumb {
        border-radius:10px;
        background:rgba(0,0,0,0.1);
        -webkit-box-shadow:inset006pxrgba(0,0,0,0.5);
    }
}
.el-message-box{
    max-width: 420px;
    width:auto;
}

</style>



// WEBPACK FOOTER //
// packages/chat/src/index.vue